import { initialFacilityAggregateSearch } from 'app/ComponentLibrary/Filter/FacilitySearch/Index';

/**
 * Task search filter names and default values for Global Search Tasks page.
 * Aligned with API request keys (e.g. statuses -> taskStatusIds in selectedChipFilters).
 */
export enum taskSearchFilterName {
  status = 'taskStatusIds',
  /** From = user who sent the task; maps to senderIds in API (createdByIds in selectedChipFilters). */
  from = 'createdByIds',
  /** Recipients = users who are To or CC on the task; maps to recipientIds in API. */
  recipients = 'recipientIds',
  /** Sent Date = date range the task was sent; used to populate sentDateMin/sentDateMax in API. */
  sentDateRange = 'sentDateRange',
  /** Follow-Up = Yes/No multi-select; maps to isFollowUp in API. */
  followUp = 'followUpFilter',
  /** Follow-Up Date = date range for follow-up; used to populate followUpDateMin/followUpDateMax in API. */
  followUpDateRange = 'followUpDateRange',
  /** Priority = Yes/No multi-select; maps to priorities array in API. */
  priority = 'priorities',
  /** Option Approval = Yes/No multi-select; maps to isOptionApproval in API. */
  optionApproval = 'optionApprovalFilter',
  /** Categories = multi-select; maps to categoryIds in API. */
  categories = 'taskCategories',
  /** Facility = facilityIds filter, shared with order/margin filters. */
  facility = 'facilityIds',
  /** OID = orderIds filter, shared with order/margin filters. */
  oid = 'orderIds',
  /** PID = placementIds filter for placement ID search. */
  pid = 'placementIds',
}

/** Default filter values for Tasks. New and Pending are checked by default. */
export const defaultFilterValues = {
  [taskSearchFilterName.status]: [
    { id: 1, name: 'New', value: 1 },
    { id: 2, name: 'Pending', value: 2 },
  ],
  [taskSearchFilterName.from]: [],
  [taskSearchFilterName.recipients]: [],
  [taskSearchFilterName.sentDateRange]: null,
  [taskSearchFilterName.followUp]: [],
  [taskSearchFilterName.followUpDateRange]: null,
  [taskSearchFilterName.priority]: [],
  [taskSearchFilterName.optionApproval]: [],
  [taskSearchFilterName.categories]: [],
  [taskSearchFilterName.facility]: initialFacilityAggregateSearch,
  [taskSearchFilterName.oid]: [],
  [taskSearchFilterName.pid]: [],
};

/** Default column visibility for Global Search Tasks grid. */
export const TASKS_DEFAULT_COLUMN_VISIBILITY: Record<string, boolean> = {
  affiliateContactID: false,
  facilityContactID: false,
};
